module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/th_6-d695351c8abf53d52f17d94205f28201.jpg";